// Custom modal component for product quick view
class ProductQuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.product-quick-view-overlay');
    this.container = this.querySelector('.product-quick-view-container');
    this.closeButtons = this.querySelectorAll('[data-quick-view-close]');
    this.isOpen = false;
  }

  connectedCallback() {
    // Use event delegation for close buttons (handles dynamically added buttons)
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-quick-view-close]')) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
        return;
      }
    });

    // Close on overlay click (only when clicking the overlay background, not its children)
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        // Only close if clicking directly on the overlay, not on the container or its children
        if (e.target === this.overlay) {
          e.preventDefault();
          e.stopPropagation();
          this.close();
        }
      });
    }
    
    // Prevent clicks inside container from bubbling to overlay
    // But allow close button clicks to propagate to the modal's event delegation handler
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        // Don't stop propagation for close button clicks
        if (!e.target.closest('[data-quick-view-close]')) {
          e.stopPropagation();
        }
      });
    }

    // Close on Escape key
    this.handleEscape = (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      }
    };
    document.addEventListener('keydown', this.handleEscape);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscape);
  }

  open(animateImmediately = true) {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-open');
    this.classList.remove('overlay-visible'); // Ensure overlay starts at opacity 0
    lockBodyScroll();
    
    // Ensure overlay is rendered before opacity transition
    // Use requestAnimationFrame to allow browser to render display:block first
    requestAnimationFrame(() => {
      this.classList.add('overlay-visible'); // Trigger fade-in after render
    });
    
    // Only trigger animation immediately if requested, otherwise wait for content to load
    if (animateImmediately) {
      requestAnimationFrame(() => {
        this.classList.add('animating-in');
      });
    }
  }

  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.classList.add('animating-out');
    this.classList.remove('animating-in', 'overlay-visible');
    
    // Wait for animation to complete (0.25s = 250ms)
    setTimeout(() => {
      this.setAttribute('aria-hidden', 'true');
      this.classList.remove('is-open', 'animating-out');
      unlockBodyScroll();
    }, 250); // Match animation duration
  }
}

customElements.define('product-quick-view-modal', ProductQuickViewModal);

